import styles from "./ConsultationType.module.scss";
import { ClockIcon } from "@/pages/MainPage/ui/assets/icons/clock";
import { classNames } from "@/shared/lib/classNames/classNames";
import consultationType from "../../../assets/consultationType.png";

const content = [
    {
        title: "Personal consultation",
        text: "The consultation includes an introduction, answers to questions, and recommendations on lifestyle and personal development.",
    },
    {
        title: "Follow-up session",
        text: "This is conducted when you were unable to discuss all pressing issues during the first consultation, or after 3 months of following the recommendations from the first consultation.",
    },
    {
        title: "Family consultation",
        text: "A family consultation will help you and your partner find answers to pressing questions, as well as recommendations on how to build your relationship with each other.",
    },
];

export const ConsultationType = () => {
    return (
        <div className={styles.consultationType}>
            <div className={styles.photoBlock}>
                <div className={styles.photoTitle}>Consultation types</div>
                <div className={styles.photoContainer}>
                    <img src={consultationType} />
                </div>
                <div className={styles.photoTime}>
                    <ClockIcon width={48} height={48} />
                    <span>90 min</span>
                </div>
            </div>
            <div className={styles.contentBlock}>
                {content.map((item, index) => (
                    <div className={styles.contentLine} key={index}>
                        <div
                            className={classNames(styles.contentIcon, {}, [
                                styles[`icon${index}`],
                            ])}
                        />
                        <div className={styles.contentTextWrapper}>
                            <div className={styles.contentTitle}>
                                {item.title}
                            </div>
                            <div className={styles.contentText}>
                                {item.text}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
